import { HttpHandlerFn, HttpInterceptorFn, HttpParams, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { LoginService } from '../../services/storage/login.service';

export const ACCESS_TOKEN_INTERCEPTOR: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
    if (req.url.indexOf(environment.apiServer) === -1) {
        return next(req);
    }

    const storageService = inject(LoginService);

    let params = new HttpParams({ fromString: req.params.toString() });
    let headers = req.headers;

    if (params.get('noToken')) {
        params = params.delete('noToken');
    } else if (storageService.getAccessToken()) {
        headers = headers.set('Authorization', `Bearer ${storageService.getAccessToken()}`);
    }

    req = req.clone({
        params: params,
        headers: headers,
    });

    return next(req);
};
